import React, { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import LoaderComponent from '../../components/Loader/LoaderComponent';
import Select from 'react-select';
import './PeopleComponent.css';
import { getUsers } from '../../services/UserService';
import { useDispatch } from 'react-redux';
import UserProfile from '../Profile/ProfileComponent';
import TimesheetsComponent from '../Timesheets/TimesheetsComponent';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { SHOW_NOTIFICATION, specialCharValidation } from '../../constants';

const PeopleComponent = (props) => {
  const [loader, setLoader] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [userSelected, setUserSelected] = useState(false);
  const [selected, setSelected] = useState('');
  const [isLastActionFocus, setIsLastActionFocus] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  const dipatchPeopleId = (empId) => {
    dispatch({
      type: 'PEOPLE_PAGE',
      data: {
        id: empId,
      },
    });
  };

  const getNames = async (name) => {
    if (name.length >= 1) {
      setIsLoading(true);
      const userList = await getUsers(name, '', '', 'ACTIVE');
      if (userList.isError === false) {
        setUsers((prev) => []);
        if (userList.data.content) {
          userList.data.content.forEach((user) => {
            const newObj = {
              value: user.id,
              label: user.firstName + ' ' + user.lastName + " (" + user.employeeCode + ")",
            };
            setUsers((prev) => [...prev, newObj]);
          });
          setIsLoading(false);
        }
      }
      if (userList.status !== 200) {
        dipatchNotification(userList.type, userList.message);
      }
    } else {
      setIsLoading(false);
    }
  };

  const optimizedFn = useCallback(debounce(getNames), []);

  const handleInputChange = (e) => {
    const inputValue = e;
    setIsLastActionFocus(false);
    if (inputValue !== '') {
      optimizedFn(inputValue);
      setSelected(inputValue);
    } else {
      setUsers([]);
    }
  };

  return (
    <div>
      {loader ? (
        <div>
          <LoaderComponent loaderType="circular" />
        </div>
      ) : (
        <Box className="main-content-overlay">
          <div className="main-content-div ">
            <div className="flex-center-container">
              {!location.pathname.includes('timings') && (
                <div className="search-bar">
                  <Select
                    blurInputOnSelect={true}
                    className="search-select"
                    classNamePrefix="select"
                    placeholder="Please select the employee name / ID..."
                    name="color"
                    isLoading={isLoading}
                    options={users}
                    onKeyDown={(e) => {
                      if (!specialCharValidation(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onInputChange={handleInputChange}
                    onFocus={() => {
                      setIsLastActionFocus(true);
                    }}
                    onBlur={() => {
                      setIsLastActionFocus(false);
                    }}
                    value={
                      isLastActionFocus
                        ? ''
                        : location.pathname.slice(12) === ''
                          ? ''
                          : selected
                    }
                    onChange={(choice) => {
                      setUserSelected(false);
                      setSelected(choice);
                      dipatchPeopleId(choice.value);
                      navigate('/user-people/' + choice.label);
                      setUserSelected(true);
                    }}
                  />
                </div>
              )}
            </div>
            {!userSelected ? (
              ''
            ) : (
              <Routes>
                <Route path=":profile" element={<UserProfile />} />
                <Route
                  path=":profile/user-timings"
                  element={<TimesheetsComponent />}
                />
              </Routes>
            )}
          </div>
        </Box>
      )}
    </div>
  );
};

export default PeopleComponent;
